<template>
  <div class="quality-difference-box">
    <div class="font-weight-bold">{{ translate('Check Quality Difference') }}</div>

    <div class="d-flex gap-10px flex-column">

      <div class="quality-difference-btn" @click="openComparePage()">
        <div class="d-flex align-items-center gap-10px h-100">
          <div class="quality-difference-icon bg-main-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
              <path d="M14.8588 1.11565C15.4496 1.50946 15.6103 2.30913 15.2165 2.89984L13.5448 5.39931H16.0724C16.7837 5.39931 17.3583 5.97395 17.3583 6.68521C17.3583 7.39647 16.7837 7.97111 16.0724 7.97111H11.833L9.26116 11.8288H16.0724C16.7837 11.8288 17.3583 12.4035 17.3583 13.1147C17.3583 13.826 16.7837 14.4006 16.0724 14.4006H7.54528L4.92526 18.3266C4.53145 18.9173 3.73178 19.0781 3.14107 18.6843C2.55036 18.2905 2.38962 17.4908 2.78343 16.9001L4.4551 14.4006H1.9275C1.21624 14.4006 0.641602 13.826 0.641602 13.1147C0.641602 12.4035 1.21624 11.8288 1.9275 11.8288H6.16696L8.73876 7.97111H1.9275C1.21624 7.97111 0.641602 7.39647 0.641602 6.68521C0.641602 5.97395 1.21624 5.39931 1.9275 5.39931H10.4546L13.0747 1.47329C13.4685 0.882578 14.2681 0.721841 14.8588 1.11565Z" fill="#E8EAED"/>
            </svg>
          </div>
          <div>
            {{ translate('Calculate Quality Loss') }}
          </div>
        </div>
        <div><i class="far fa-arrow-right"></i></div>
      </div>

    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import Analytics from "../../util/Analytics";
import { translate } from '../../../../../../helper/translate';
import {satGlobals} from "../../../../../../sat/helper/sat-globals";

export default {
  name: "QualityDifference",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    async openComparePage() {
      await Analytics.send('result_action', 'check_quality_difference', this.currentJob);

      const originalInputJob = this.currentJob.apiJob.id;
      const processedOutput = this.currentJob.apiJob.output[0].uri;

      const locale = satGlobals.getLocale();

      let comparePage;
      let url;
      
      if (satGlobals.getProjectName().toLowerCase() === 'img2go') {
        comparePage = 'compare-image';
      }

      if (satGlobals.getProjectName().toLowerCase() === 'video2edit') {
        comparePage = 'compare-video';
      }

      if (locale !== 'en') {
        url = `${locale}/${comparePage}#j=${originalInputJob}&remote_url=${processedOutput}`
      } else {
        url = `/${comparePage}#j=${originalInputJob}&remote_url=${processedOutput}`
      }
      window.open(url);
    },
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.quality-difference-box {
  display: flex;
  flex-direction:column;
  gap: 20px;

  .quality-difference-btn {
    overflow:hidden;
    display: flex;
    background: #F8F9FA;
    border: 1px solid #CBCBCB;
    border-radius: 4px;
    justify-content: space-between;
    padding: 5px 20px 5px 5px;
    height: 42px;
    align-items: center;
    cursor: pointer;
  
    .dark-mode & {
      background:#383838;;
      border: 1px solid #595959;
      color: white;
      &:hover {
        background: #323232;
      }
    }
  
    &:hover {
      background: #F2F2F2;
    }
  }

  .quality-difference-icon {
    display: flex;
    width: 30px;
    height: 100%;
    padding: 2px 1px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 2px;
  }
}
.disabled {
  opacity: .5;
  cursor: not-allowed !important;
}
</style>
